<template>
  <v-card class="kanban-column" flat :color="color">
    <v-toolbar class="pt-1" color="transparent" dense flat height="44">
      <span class="body-2 text--secondary font-weight-medium text-uppercase">{{label}}</span>
      <v-chip class="ml-2" color="defaultGrey" label small text-color="secondary">{{items.length}}</v-chip>
    </v-toolbar>
    <draggable :list="items" :group="{ name: 'board' }" :move="onMove" :data-column-key="columnKey" handle=".kanban-card" ghost-class="kanban-card-ghost" animation="150" class="kanban-column-body pa-2 pt-0" @change="onChange">
      <span v-if="!items.length" class="d-block text-center caption text--secondary py-6">Sin registros</span>
      <kanban-card v-for="item in items" :key="`${item.kind}-${item.id}`" :item="item" @action="$emit('action', $event)" />
    </draggable>
  </v-card>
</template>
<script>
import draggable from 'vuedraggable'
import KanbanCard from '@/components/supporting-documents/KanbanCard'

export default {
  components: {
    draggable,
    KanbanCard
  },
  props: {
    color: {
      type: String,
      default: () => 'background'
    },
    columnKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    canDrop: {
      type: Function,
      default: () => () => false
    }
  },
  methods: {
    onMove (evt) {
      const toEl = evt.to
      const toKey = toEl && toEl.dataset ? toEl.dataset.columnKey : null
      const item = evt.draggedContext && evt.draggedContext.element

      if (!toKey || !item) {
        return false
      }

      if (toKey === this.columnKey) {
        return false
      }

      return this.canDrop({ fromKey: this.columnKey, toKey, item })
    },
    onChange (evt) {
      if (evt.added) {
        this.$emit('item-added', { toKey: this.columnKey, item: evt.added.element })
      }
    }
  }
}
</script>
<style scoped>
.kanban-column {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(100vh - 265px);
  max-width: 280px;
  min-width: 280px;
  overflow-y: auto;
}

.kanban-column-body {
  flex: 1 1 auto;
  min-height: 60px;
  overflow-y: auto;
}
</style>
